import { defineMessages } from 'react-intl';

const messages = defineMessages({
  forgotRequestTitle: {
    id: 'accountSignin.forgotPassword.request.title',
    defaultMessage: 'Forgot password - Request password reset',
    description: 'Page title for start of forgot password flow',
  },
  forgotEmailSentTitle: {
    id: 'accountSignin.forgotPassword.emailSent.title',
    defaultMessage: 'Forgot password - Reset password email sent',
    description: 'Page title for forgot password flow after email is sent',
  },
});

export default messages;
